export default __webpack_public_path__ + "static/media/Maestrale nell_ isola  - Anno 2020.5f583868.jpg";